import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22_app.tsx%22,%22import%22:%22Oswald%22,%22arguments%22:[{%22subsets%22:[%22latin%22],%22weight%22:%22700%22}],%22variableName%22:%22numbers%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Oswald', 'Oswald Fallback'",
        fontWeight: 700,
fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
